import { TeamCategoryChipIcon } from "@components/table/teams/team-category-chip-icon";
import { teamDisplayProperties } from "@components/table/teams/teams-table-utils";
import { Stack } from "@mui-wrapper";
import { InviteMemberToTeam } from "@pages/members/teams/invite-member-to-team";
import { TeamTabs } from "@router/route-params";
/**
 * Returns the action to be rendered in the info bar of the team details page based on the selected team and tab
 * If the team is auto-managed, it will display the team category chip icon, because the user should not manually invite members.
 * If the team is not auto-managed and the members tab is active, it will display the invite member button.
 * If none of the above conditions are met, it will return null, meaning no action will be rendered in the info bar.
 * Uses a function instead of a JSX component because the parent needs to evaluate whether the content will be empty,
 * meaning no hooks should be used inside the function.
 */
export function getTeamDetailsInfoBarAction({
  selectedTeam,
  teamTabs
}) {
  const isMembersTab = teamTabs === TeamTabs.members;
  const canInvite = selectedTeam.memberCount && !selectedTeam.category.isManaged;
  const isAutoManaged = teamDisplayProperties[selectedTeam.category.kind].isAutoManaged;
  if (isAutoManaged) {
    return <Stack sx={{
      alignItems: "end"
    }}>
        <TeamCategoryChipIcon kind={selectedTeam.category.kind} shouldShowText={true} />
      </Stack>;
  }
  if (isMembersTab && canInvite) {
    return <InviteMemberToTeam team={selectedTeam} />;
  }
  return null;
}